import axios, { AxiosResponse } from 'axios';
import i18next from 'i18next';
import { ENV } from '../config/env';
import { setToast } from '../store/core/coreSlice';
import { store } from '../store/store';
import { netCheck, onFulfilled, onRejected, onRejectedHandled } from './middleware';

export const api = axios.create({
  baseURL: ENV.API_URL,
});

export const apiRQ = axios.create({
  baseURL: ENV.API_URL,
});

api.interceptors.request.use(onFulfilled, onRejected);

apiRQ.interceptors.request.use(onFulfilled, onRejected);

// Cancel request if there is no internet
api.interceptors.request.use(netCheck, onRejected);
apiRQ.interceptors.request.use(netCheck, onRejected);

const getErrorMsg = (data: AxiosResponse) => {
  let msg = 'API_ERRORS.SOMETHING_WENT_WRONG';
  if (data?.data?.errorCode || data?.data?.message) {
    if (i18next.exists(`API_ERRORS.${data?.data?.errorCode}`)) {
      msg = `API_ERRORS.${data?.data?.errorCode}`;
    }

    if (i18next.exists(`API_ERRORS.${data?.data?.message}`)) {
      msg = `API_ERRORS.${data?.data?.message}`;
    }
  }

  return msg;
};

// Add a response interceptor for errors
api.interceptors.response.use((response: AxiosResponse) => {
  if ((response?.data?.errorCode || response?.data?.error) && !response.data.success) {
    store.dispatch(setToast({ value: { show: true, msg: i18next.t(getErrorMsg(response)), isError: true } }));
  }

  return response;
}, onRejectedHandled);

apiRQ.interceptors.response.use((response: AxiosResponse) => {
  if (response?.data?.success) return response;

  if (response?.data?.errorCode || response?.data?.message) {
    store.dispatch(setToast({ value: { show: true, msg: i18next.t(getErrorMsg(response)), isError: true } }));
    return response;
  }

  if (response?.data?.error) {
    // `error` is expected to be a string; guard against a non-string value (e.g. a raw error
    // object leaking through from the server) reaching the toast/Redux store as-is.
    const msg =
      typeof response.data.error === 'string' ? response.data.error : i18next.t('API_ERRORS.SOMETHING_WENT_WRONG');
    store.dispatch(setToast({ value: { show: true, msg, isError: true } }));
  }

  return response;
}, onRejectedHandled);
